
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFactura"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FacturaInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFactura"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CantReg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"PtoVta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CbteTipo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Concepto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"DocTipo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"DocNro"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CbteDesde"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CbteHasta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CbteFch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ImpTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ImpTotConc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ImpNeto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ImpOpEx"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ImpIVA"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ImpTrib"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"MonId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"MonCotiz"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CAE"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CAEFchVto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"VoucherNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Error"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Estado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CuitEmisor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"FchServDesde"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"FchServHasta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"FchVtoPago"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CondicionIVAReceptor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"RazonSocialReceptor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"DomicilioReceptor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CondicionVenta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ProductoServicio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Alicuota"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"detalleProductoServicio"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codigo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ProductoServicio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cantidad"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unidadMedida"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioUnitario"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioUnitarioConIva"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bonificacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alicuotaIva"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alicuotaIvaPorcentaje"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subtotalConIva"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"Iva"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"BaseImp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Importe"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1093}};
    doc.loc.source = {"body":"mutation createFactura($input: FacturaInput){\n    createFactura(input: $input){\n        id\n        CantReg\n        PtoVta\n        CbteTipo\n        Concepto\n        DocTipo\n        DocNro\n        CbteDesde\n        CbteHasta\n        CbteFch\n        ImpTotal\n        ImpTotConc\n        ImpNeto\n        ImpOpEx\n        ImpIVA\n        ImpTrib\n        MonId\n        MonCotiz\n        CAE\n        CAEFchVto\n        VoucherNumber\n        Error\n        Estado\n        CuitEmisor\n        FchServDesde\n        FchServHasta\n        FchVtoPago\n        CondicionIVAReceptor\n        RazonSocialReceptor\n        DomicilioReceptor\n        CondicionVenta\n        ProductoServicio\n        Alicuota\n        detalleProductoServicio{\n            codigo\n            ProductoServicio\n            cantidad\n            unidadMedida\n            precioUnitario\n            precioUnitarioConIva\n            bonificacion\n            subtotal\n            alicuotaIva\n            alicuotaIvaPorcentaje\n            subtotalConIva\n        }\n        Iva{\n            Id\n            BaseImp\n            Importe\n        }\n    }\n}\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["createFactura"] = oneQuery(doc, "createFactura");
        
